import {
  PasswordRequirementChecks,
  PasswordRequirements,
} from "../@types/PasswordRequirements";

/**
 * Arguments to validatePassword.
 */
interface ValidatePasswordArgs {
  requirements: PasswordRequirements;
  password: string;
  confirmPassword: string;
}

/**
 * Validate a password and return a {@link PasswordRequirementChecks} containing information about the validation.
 * @param {ValidatePasswordArgs} args The arguments.
 */
export default function validatePassword(
  args: ValidatePasswordArgs,
): PasswordRequirementChecks {
  const { password, confirmPassword, requirements } = args;

  const hasUppercase = () => (password.match(/[A-Z]/g) || []).length > 0;
  const hasLowercase = () => (password.match(/[a-z]/g) || []).length > 0;
  const hasNumber = () => (password.match(/[0-9]/g) || []).length > 0;
  const hasSpecialChar = () => (password.match(/[\W_]/g) || []).length > 0;

  const result: PasswordRequirementChecks = {
    minLengthSatisfied: password.length >= requirements.minLength,
    maxLengthSatisfied: password.length <= requirements.maxLength,
    equal: password === confirmPassword,
  };
  if (requirements.requireMixedCase) {
    result.mixedCaseSatisfied = hasUppercase() && hasLowercase();
  }

  if (requirements.requireNumber) {
    result.numberSatisfied = hasNumber();
  }

  if (requirements.requireNonAlpha) {
    result.nonAlphaSatisfied = hasSpecialChar();
  }

  return result;
}
